import { cva } from 'class-variance-authority';

export const Container = cva(['animate-pulse']);

export const Title = cva(['h-9', 'w-44', 'rounded-md', 'bg-gray-200']);
